import React, { useEffect, useState } from "react";
import SimpleCard from "@qlik/qlik/src/components/SimpleCard";
import ContentSlider from "@qlik/qlik/src/components/ContentSlider";
import { formatDate } from "@qlik/qlik/src/lib/util/dates";
import * as styles from "./styles.module.css";
import { useI18n } from "@qlik/utils/i18nContext";

/**
 * DeckNews component
 * @param {Object} data - The data for the component
 * @returns {JSX.Element} - Rendered component
 */
const DeckNews = ({ data }) => {
    const { title, cardItems = [], customId } = data ?? {};
    // State for total slides
    const [totalSlides, setTotalSlides] = useState(2);

    // Get the i18n information for formatting dates
    const { i18n } = useI18n();

    // Effect to set total slides based on card items length
    useEffect(() => {
        if (cardItems.length === 1) {
            setTotalSlides(1);
        }
    }, [cardItems]);

    // Slider settings
    const settings = {
        slidesToShow: totalSlides,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 475,
                settings: {
                    slidesToShow: 2,
                    dots: true,
                    arrows: false,
                },
            },
        ],
    };

    // Render
    return (
        <section className="overflow-hidden qlik-news pt-15 pb-12.5 lg:py-25" id={customId}>
            <div className="container px-10 md:px-3.75">
                {title && <h2 className={`text-blue ${styles.heading}`}>{title}</h2>}
                <div
                    role="region"
                    aria-label="Carousel"
                    aria-live="polite"
                    className="card-list relative slick-arrow-top-right slick-right-visible slick-slider-dots"
                >
                    <ContentSlider settings={settings}>
                        {cardItems?.map((card) => (
                            <div key={card.name.replace(/\s+/g, "-").toLowerCase()} className="row">
                                <SimpleCard
                                    title={card.title}
                                    subHeading={card.dateTime && formatDate(card.dateTime, i18n.curr.langCode)}
                                    button={card?.cta}
                                    className="hover:shadow-md hover:no-underline before:transition-all before:duration-500 before:ease-in-out transition-all duration-300"
                                />
                            </div>
                        ))}
                    </ContentSlider>
                </div>
            </div>
        </section>
    );
};

// Export DeckNews component
export default DeckNews;
